module.exports = __webpack_public_path__ + "h5/img/vip8.b1de4ffb.png";